import { addLocaleMessages } from '@/i18n';

const zhCN = {
    patentAnalysis: {
        creationMode: { quick: '快速创建', guided: '引导式创建' },
        creationDescription: {
            quick: '创建空白项目，后续自由处理。',
            guided: '按技术三要素、技术特征、检索和专利性分析逐步完成。',
        },
        directAgent: '上传材料并直接开始 Agent',
        backToProjects: '返回项目列表',
        loading: '正在加载工作流…',
        saving: '保存中…',
        retry: '重试',
        scene: { patent_draft: '专利撰写分析', disclosure: '交底书分析' },
        steps: {
            OCR: '材料识别',
            TECHNICAL_ELEMENTS: '技术三要素',
            TECHNICAL_FEATURES: '技术特征',
            PATENTABILITY_ANALYSIS: '专利性分析',
            SOLUTION_REINFORCEMENT: '方案补强',
        },
        status: {
            LOCKED: '等待前序步骤',
            READY: '可以开始',
            QUEUED: '排队中',
            RUNNING: '执行中',
            AWAITING_CONFIRMATION: '等待确认',
            CONFIRMED: '已确认',
            FAILED: '失败',
            STALE: '需要重新执行',
            CANCELLED: '已取消',
            SKIPPED: '已跳过',
        },
        source: {
            title: '第一步：提供技术方案',
            description: '直接输入方案，或上传最多 5 份材料并使用独立工作流 OCR。',
            textMode: '输入方案',
            fileMode: '上传文件',
            textPlaceholder: '请描述技术问题、技术方案、关键结构/步骤以及预期技术效果…',
            textHint: '确认后将形成不可变输入版本，并进入技术三要素抽取。',
            confirm: '确认方案并继续',
            chooseFiles: '选择技术材料',
            uploading: '正在上传文件…',
            fileLimit: '已添加 {count}/{max} 个文件；文件上传与文本输入互斥',
            startOcr: '开始识别',
            retryOcr: '重试失败文件',
            startingOcr: '正在启动识别…',
            confirmOcr: '确认识别结果并继续',
            confirmingOcr: '正在确认…',
            materialRole: '材料角色',
            moveUp: '上移材料',
            moveDown: '下移材料',
            ignoreFailed: '忽略此文件',
            deleteFile: '删除此文件',
            candidateDates: '材料中识别出的日期',
            candidateDatesHint: '这些日期仅作为检索截止日建议，进入检索前仍需人工确认。',
            dateTypes: {
                APPLICATION_DATE: '申请日',
                PRIORITY_DATE: '优先权日',
                PUBLICATION_DATE: '公开日',
                DOCUMENT_DATE: '文档日期',
            },
            fileStatus: {
                UPLOADED: '等待识别',
                QUEUED: '排队中',
                RUNNING: '识别中',
                COMPLETED: '识别完成',
                FAILED: '识别失败',
                IGNORED: '已忽略',
            },
            roles: {
                PRIMARY_DISCLOSURE: '主交底材料',
                SUPPLEMENT: '补充材料',
                DRAWING: '附图',
                PRIOR_ART: '现有技术',
            },
        },
        structured: {
            elementsDescription: '从已确认材料中抽取技术问题、技术方案、技术效果及证据关联。',
            featuresDescription: '基于已确认三要素抽取必要、可选、参数、关系及检索关键词。',
            readyHint: '本步骤会创建独立执行记录，结果生成后需要人工确认。',
            start: '开始结构化抽取',
            starting: '正在启动…',
            queued: '任务已进入队列，请稍候…',
            running: '正在执行结构化抽取，结果会自动刷新…',
            failed: '本步骤执行失败，可以保留历史记录后重新执行。',
            retry: '重新执行',
            loadingResult: '正在加载结构化结果…',
            problems: '技术问题',
            solutions: '技术方案',
            effects: '技术效果',
            features: '技术特征',
            connections: '连接',
            boardHint: '点击任意技术问题 / 方案 / 效果卡片查看它的关联。问题、方案、效果之间是多对多关系,数量并不一一对应。',
            boardSelectedPrefix: '已选',
            boardSelectedArrow: '→ 直接关联',
            boardNone: '无',
            expand: '展开',
            collapse: '收起',
            mappingQuality: {
                title: '完整度',
                good: '完整',
                partial: '部分缺失',
                weak: '较弱',
                missing: '缺失',
            },
            claimPosition: {
                independent_claim: '独立权利要求',
                dependent_claim: '从属权利要求',
                embodiment: '仅实施例',
                background_only: '仅背景技术',
                not_recommended: '不建议入权',
                to_be_confirmed: '待确认',
            },
            necessity: {
                necessary: '必要',
                important_optional: '重要可选',
                optional: '可选',
                alternative: '替代方案',
                non_technical: '非技术特征',
                uncertain: '待确认',
            },
            disclosureSufficiency: {
                sufficient: '披露充分',
                partial: '部分披露',
                insufficient: '披露不足',
                conflicting: '存在冲突',
                unknown: '未知',
            },
            table: {
                name: '特征名称',
                description: '功能解释',
                necessity: '必要性',
                claimPosition: '权利要求定位',
                disclosureSufficiency: '披露情况',
                confidence: '置信度',
                includeInDisclosure: '计入披露',
                inferred: '是否推断',
                inferredYes: 'AI 推断',
                technicalNature: '技术本质',
                reason: '判断理由',
                keywords: '关键词',
                synonyms: '同义表达',
                related: '关联',
                parameters: '参数',
                paramName: '参数名',
                paramValue: '取值/范围',
                paramUnit: '单位',
                paramDisclosed: '已披露',
            },
            removalTest: {
                title: '去除测试',
                solution_still_works_without_it: '去除后方案仍成立',
                core_problem_still_solved: '去除后核心问题仍解决',
                core_effect_still_achieved: '去除后核心效果仍达成',
                alternative_exists: '存在替代方案',
                is_preferred_embodiment_only: '仅优选实施例',
            },
            evidence: '原文依据',
            questions: '需要补充确认的问题',
            confirm: '确认并进入下一步',
            confirming: '正在确认…',
            discardEdit: '放弃修改',
            saveEdit: '保存修改',
        },
        searchPlan: {
            title: '第三步：确认检索计划',
            description: '确认截止日、检索范围、查询式和各分支结果上限；确认后才会启动外部检索。',
            empty: '系统将根据已确认技术特征生成可编辑的检索计划。',
            stale: '上游技术特征已经变化，当前检索计划已失效，请重新生成。',
            generate: '生成检索计划',
            generating: '正在生成…',
            status: { DRAFT: '草稿', CONFIRMED: '已确认' },
            cutoff: '现有技术检索截止日',
            dateEvidence: '日期证据',
            countries: '国家/地区',
            countriesPlaceholder: '例如：CN, US, EP；留空表示不限制',
            countriesHint: '使用二或三位国家/地区代码，多个代码用逗号分隔。',
            documentTypes: '专利文献类型',
            documentType: {
                APPLICATION: '申请公开',
                GRANT: '授权专利',
                UTILITY_MODEL: '实用新型',
            },
            queries: '检索查询',
            queryTraceability: '每条查询均保留 Feature / Combination 引用',
            branch: {
                STRUCTURED_PATENT_SEARCH: '结构化专利检索',
                FEATURE_SEMANTIC_SEARCH: '技术特征语义检索',
                SOURCE_SEMANTIC_SEARCH: '完整方案语义检索',
                FEATURE_COMBINATION_SEARCH: '关键特征组合检索',
                PAPER_SEARCH: '论文检索（辅助）',
                WEB_SEARCH: 'Web 检索（辅助）',
            },
            required: '必选',
            rows: '上限',
            notes: '计划备注',
            revision: '计划 Revision {revision}',
            save: '保存计划修改',
            confirm: '确认检索计划',
            saveBeforeConfirm: '当前有未保存修改，请先保存再确认。',
            confirmedHint: '检索计划已冻结。检索只会消费这个确认版本，执行期间不会读取后续修改。',
            failedHint: '上一轮检索未形成可用专利候选。可以直接重试，或创建当前计划的可编辑新 Revision 后调整查询。',
            revise: '调整检索计划',
        },
        searchResults: {
            title: '第四步：执行检索并确认候选集',
            description: '结构化与语义专利分支并行执行；论文和 Web 仅作为可选辅助来源。',
            start: '开始检索',
            starting: '正在启动…',
            queued: '检索任务已排队，系统将自动刷新各查询分支的执行状态。',
            running: '检索正在执行。分支结果会写入项目数据，并在全部终态后自动聚合。',
            failed: '检索没有形成可用的专利候选集。',
            retry: '重试检索',
            partial: '部分辅助或专利分支失败；以下候选集来自已成功分支，请结合分支状态确认是否继续。',
            patents: '专利候选',
            papers: '论文候选',
            web: 'Web 候选',
            filtered: '截止日后已过滤',
            branchStatus: '查询分支状态',
            patentCandidates: '专利候选集（同族去重后）',
            paperCandidates: '论文辅助结果',
            webCandidates: 'Web 辅助结果',
            provenance: '来源查询 / 技术特征',
            empty: '成功分支没有返回可确认的候选结果。请重试或调整上游检索计划。',
            cutoff: '冻结截止日',
            familyDeduplicated: '同族合并数',
            confirm: '确认候选集并继续',
            confirming: '正在确认…',
            loading: '正在加载检索结果…',
        },
        patentability: {
            title: '专利性分析',
            description: '基于已确认技术特征和冻结候选集，按单篇新颖性规则及三步法生成可追溯的技术预评估。',
            ready: '候选集已经确认，可以开始结构化专利性分析。该步骤不会重新检索。',
            start: '开始分析',
            starting: '正在启动…',
            queued: '分析任务已排队。',
            running: '正在逐一比对候选文献、技术特征和关键组合…',
            failed: '专利性分析失败，可以基于同一冻结候选集重试。',
            retry: '重试分析',
            completed: '工作流已完成，以下是已确认的最终专利性预评估。',
            riskLevel: '综合风险',
            noveltyLabel: '新颖性',
            inventivenessLabel: '创造性',
            overall: '综合结论',
            keyRisks: '主要风险',
            recommendations: '建议',
            distinguishingFeatures: '区别特征',
            limitations: '证据限制',
            candidateAnalysis: '逐篇候选文献比对',
            similarity: '相似度',
            unitAnalysis: '关键组合分析',
            objectiveProblem: '客观技术问题',
            technicalEffect: '技术效果',
            draftingAdvice: '权利要求撰写建议',
            disclosureAdvice: '交底材料完善建议',
            independentFeatures: '建议的独立权利要求特征',
            emphasizeFeatures: '建议强调',
            avoidFeatures: '不宜作为唯一差异',
            draftingNotes: '撰写说明',
            supportedFeatures: '已有充分支持的区别特征',
            unsupportedFeatures: '支持不足的区别特征',
            evidenceGaps: '证据缺口',
            inventorQuestions: '发明人问题',
            confirm: '确认报告并完成工作流',
            confirming: '正在确认…',
            loading: '正在加载专利性分析…',
            risk: {
                low: '低',
                medium: '中',
                high: '高',
                uncertain: '不确定',
            },
            novelty: {
                novelty_risk: '存在新颖性风险',
                likely_novel: '当前检索范围内可能具备新颖性',
                insufficient_evidence: '证据不足',
            },
            inventiveness: {
                obviousness_risk: '存在显而易见风险',
                inventive_indication: '存在创造性迹象',
                insufficient_evidence: '证据不足',
            },
            disclosure: {
                fully_disclosed: '完整披露',
                partially_disclosed: '部分披露',
                not_found: '未发现',
                uncertain: '不确定',
            },
        },
        handoff: {
            title: '继续在 Agent 中处理',
            description: '系统会先把已确认结果物化为可读取的 Markdown 报告，再复用当前项目创建新的文档和会话。',
            start: '进入 Agent 继续处理',
            starting: '正在准备报告并启动…',
            started: '已进入 Agent，工作流报告已加入项目附件',
        },
        reinforcement: {
            title: '方案补强',
            description: '针对新颖性/创造性风险单元给出可执行的方案补强建议。',
            readyHint: '点击开始生成方案补强建议。',
            start: '开始生成',
            starting: '正在生成…',
            queued: '已排队，等待执行',
            running: '正在生成方案补强建议…',
            failed: '方案补强生成失败',
            retry: '重试',
            loading: '正在加载结果…',
            confirming: '正在确认…',
            confirm: '确认结果',
            direction: '补强方向',
            additionalEffect: '新增技术效果',
            draftingNotes: '撰写提示',
            summary: '补强摘要',
        },
        remaining: {
            title: '下一步骤尚未接入',
            description: '检索候选集已经可用；新颖性和创造性分析将在下一批接入。',
        },
        errors: {
            createFailed: '创建引导式项目失败，请重试',
            loadFailed: '加载工作流失败，请重试',
            saveSourceFailed: '保存技术方案失败，请刷新后重试',
            uploadSourceFailed: '上传工作流文件失败，请重试',
            updateSourceFailed: '保存材料顺序或角色失败，请刷新后重试',
            ignoreSourceFailed: '忽略失败材料失败，请刷新后重试',
            deleteSourceFailed: '删除文件失败，请刷新后重试',
            loadStepFailed: '加载步骤详情失败，请重试',
            startStepFailed: '启动步骤失败，请刷新后重试',
            saveStepFailed: '保存步骤结果失败，请刷新后重试',
            confirmStepFailed: '确认步骤失败，请刷新后重试',
            loadSearchPlanFailed: '加载检索计划失败，请重试',
            createSearchPlanFailed: '生成检索计划失败，请刷新后重试',
            saveSearchPlanFailed: '保存检索计划失败，请刷新后重试',
            confirmSearchPlanFailed: '确认检索计划失败，请刷新后重试',
            handoffFailed: '准备 Agent 交接报告失败，请刷新后重试',
            startAgentFailed: '启动 Agent 失败，交接报告已保留，可稍后重试',
        },
    },
};

const en = {
    patentAnalysis: {
        creationMode: { quick: 'Quick create', guided: 'Guided workflow' },
        creationDescription: {
            quick: 'Create an empty project and continue freely.',
            guided: 'Follow a fixed patent search and analysis workflow.',
        },
        directAgent: 'Upload materials and start Agent',
        backToProjects: 'Back to projects',
        loading: 'Loading workflow…',
        saving: 'Saving…',
        retry: 'Retry',
        scene: { patent_draft: 'Patent drafting analysis', disclosure: 'Disclosure analysis' },
        steps: {
            OCR: 'Source extraction',
            TECHNICAL_ELEMENTS: 'Technical elements',
            TECHNICAL_FEATURES: 'Technical features',
            PATENTABILITY_ANALYSIS: 'Patentability analysis',
            SOLUTION_REINFORCEMENT: 'Solution reinforcement',
        },
        status: {
            LOCKED: 'Waiting',
            READY: 'Ready',
            QUEUED: 'Queued',
            RUNNING: 'Running',
            AWAITING_CONFIRMATION: 'Needs confirmation',
            CONFIRMED: 'Confirmed',
            FAILED: 'Failed',
            STALE: 'Needs rerun',
            CANCELLED: 'Cancelled',
            SKIPPED: 'Skipped',
        },
        source: {
            title: 'Step 1: Provide the technical solution',
            description: 'Enter text or upload up to five files for workflow OCR.',
            textMode: 'Enter text',
            fileMode: 'Upload files',
            textPlaceholder: 'Describe the problem, solution, key structures or steps, and technical effects…',
            textHint: 'Confirmation creates an immutable source revision.',
            confirm: 'Confirm and continue',
            chooseFiles: 'Choose technical files',
            uploading: 'Uploading files…',
            fileLimit: '{count}/{max} files added; file and text input are exclusive',
            startOcr: 'Start extraction',
            retryOcr: 'Retry failed files',
            startingOcr: 'Starting extraction…',
            confirmOcr: 'Confirm extracted sources',
            confirmingOcr: 'Confirming…',
            materialRole: 'Material role',
            moveUp: 'Move material up',
            moveDown: 'Move material down',
            ignoreFailed: 'Ignore file',
            deleteFile: 'Delete file',
            candidateDates: 'Dates detected in source materials',
            candidateDatesHint: 'These are suggestions only. Confirm the search cutoff date before searching.',
            dateTypes: {
                APPLICATION_DATE: 'Filing date',
                PRIORITY_DATE: 'Priority date',
                PUBLICATION_DATE: 'Publication date',
                DOCUMENT_DATE: 'Document date',
            },
            fileStatus: {
                UPLOADED: 'Ready',
                QUEUED: 'Queued',
                RUNNING: 'Extracting',
                COMPLETED: 'Completed',
                FAILED: 'Failed',
                IGNORED: 'Ignored',
            },
            roles: {
                PRIMARY_DISCLOSURE: 'Primary disclosure',
                SUPPLEMENT: 'Supplement',
                DRAWING: 'Drawing',
                PRIOR_ART: 'Prior art',
            },
        },
        structured: {
            elementsDescription: 'Extract problems, solutions, effects, mappings, and source evidence.',
            featuresDescription: 'Extract necessary, optional, relational, and parameter features for search.',
            readyHint: 'This creates an auditable attempt. Review and confirm the result before continuing.',
            start: 'Start structured extraction',
            starting: 'Starting…',
            queued: 'The task is queued…',
            running: 'Structured extraction is running. Results refresh automatically…',
            failed: 'This step failed. You can retry without overwriting its history.',
            retry: 'Run again',
            loadingResult: 'Loading structured result…',
            problems: 'Technical problems',
            solutions: 'Technical solutions',
            effects: 'Technical effects',
            features: 'Technical features',
            connections: 'links',
            boardHint: 'Click any problem / solution / effect card to see its links. Problems, solutions, and effects form a many-to-many network — the counts do not line up one to one.',
            boardSelectedPrefix: 'Selected',
            boardSelectedArrow: '→ directly linked to',
            boardNone: 'none',
            expand: 'Expand',
            collapse: 'Collapse',
            mappingQuality: {
                title: 'Integrity',
                good: 'Complete',
                partial: 'Partial',
                weak: 'Weak',
                missing: 'Missing',
            },
            claimPosition: {
                independent_claim: 'Independent claim',
                dependent_claim: 'Dependent claim',
                embodiment: 'Embodiment only',
                background_only: 'Background only',
                not_recommended: 'Not recommended for claims',
                to_be_confirmed: 'To be confirmed',
            },
            necessity: {
                necessary: 'Necessary',
                important_optional: 'Important optional',
                optional: 'Optional',
                alternative: 'Alternative',
                non_technical: 'Non-technical',
                uncertain: 'Uncertain',
            },
            disclosureSufficiency: {
                sufficient: 'Sufficient',
                partial: 'Partial',
                insufficient: 'Insufficient',
                conflicting: 'Conflicting',
                unknown: 'Unknown',
            },
            table: {
                name: 'Feature',
                description: 'Description',
                necessity: 'Necessity',
                claimPosition: 'Claim position',
                disclosureSufficiency: 'Disclosure',
                confidence: 'Confidence',
                includeInDisclosure: 'In disclosure',
                inferred: 'Inferred',
                inferredYes: 'AI inferred',
                technicalNature: 'Technical nature',
                reason: 'Reason',
                keywords: 'Keywords',
                synonyms: 'Synonyms',
                related: 'Related',
                parameters: 'Parameters',
                paramName: 'Name',
                paramValue: 'Value / range',
                paramUnit: 'Unit',
                paramDisclosed: 'Disclosed',
            },
            removalTest: {
                title: 'Removal test',
                solution_still_works_without_it: 'Solution still works without it',
                core_problem_still_solved: 'Core problem still solved',
                core_effect_still_achieved: 'Core effect still achieved',
                alternative_exists: 'Alternative exists',
                is_preferred_embodiment_only: 'Preferred embodiment only',
            },
            evidence: 'Source evidence',
            questions: 'Questions requiring confirmation',
            confirm: 'Confirm and continue',
            confirming: 'Confirming…',
            discardEdit: 'Discard changes',
            saveEdit: 'Save changes',
        },
        searchPlan: {
            title: 'Step 3: Confirm the search plan',
            description: 'Confirm the cutoff date, scope, queries, and branch limits before external retrieval starts.',
            empty: 'Generate an editable plan from the confirmed technical features.',
            stale: 'The upstream features changed. Regenerate this stale search plan.',
            generate: 'Generate search plan',
            generating: 'Generating…',
            status: { DRAFT: 'Draft', CONFIRMED: 'Confirmed' },
            cutoff: 'Prior-art cutoff date',
            dateEvidence: 'Date evidence',
            countries: 'Countries / regions',
            countriesPlaceholder: 'For example: CN, US, EP; blank means no restriction',
            countriesHint: 'Use two- or three-letter codes separated by commas.',
            documentTypes: 'Patent document types',
            documentType: {
                APPLICATION: 'Applications',
                GRANT: 'Grants',
                UTILITY_MODEL: 'Utility models',
            },
            queries: 'Search queries',
            queryTraceability: 'Every query retains Feature / Combination references',
            branch: {
                STRUCTURED_PATENT_SEARCH: 'Structured patent search',
                FEATURE_SEMANTIC_SEARCH: 'Feature semantic search',
                SOURCE_SEMANTIC_SEARCH: 'Full-solution semantic search',
                FEATURE_COMBINATION_SEARCH: 'Feature-combination search',
                PAPER_SEARCH: 'Paper search (auxiliary)',
                WEB_SEARCH: 'Web search (auxiliary)',
            },
            required: 'Required',
            rows: 'Limit',
            notes: 'Plan notes',
            revision: 'Plan revision {revision}',
            save: 'Save plan changes',
            confirm: 'Confirm search plan',
            saveBeforeConfirm: 'Save the current changes before confirming.',
            confirmedHint: 'The plan is frozen. Retrieval consumes only this confirmed revision.',
            failedHint: 'The previous retrieval produced no usable patent candidates. Retry it or create an editable revision of this plan.',
            revise: 'Revise search plan',
        },
        searchResults: {
            title: 'Step 4: Run retrieval and confirm candidates',
            description: 'Structured and semantic patent branches run in parallel; papers and web sources are optional supporting evidence.',
            start: 'Start retrieval',
            starting: 'Starting…',
            queued: 'Retrieval is queued. Query branch status will refresh automatically.',
            running: 'Retrieval is running. Branch data is persisted and aggregated after every branch reaches a terminal state.',
            failed: 'Retrieval did not produce a usable patent candidate set.',
            retry: 'Retry retrieval',
            partial: 'Some branches failed. Review the successful sources and branch status before continuing.',
            patents: 'Patent candidates',
            papers: 'Paper candidates',
            web: 'Web candidates',
            filtered: 'Filtered after cutoff',
            branchStatus: 'Query branch status',
            patentCandidates: 'Patent candidates (family deduplicated)',
            paperCandidates: 'Supporting papers',
            webCandidates: 'Supporting web sources',
            provenance: 'Source queries / technical features',
            empty: 'Successful branches returned no confirmable candidates. Retry or revise the search plan.',
            cutoff: 'Frozen cutoff',
            familyDeduplicated: 'Families merged',
            confirm: 'Confirm candidates and continue',
            confirming: 'Confirming…',
            loading: 'Loading retrieval results…',
        },
        patentability: {
            title: 'Patentability analysis',
            description: 'Compare frozen technical features with the confirmed candidate set using a single-reference novelty rule and a three-step inventive analysis.',
            ready: 'The candidate set is confirmed. Start structured patentability screening without running another search.',
            start: 'Start analysis',
            starting: 'Starting…',
            queued: 'The analysis is queued.',
            running: 'Comparing every candidate, technical feature, and key combination…',
            failed: 'Patentability analysis failed. Retry with the same frozen candidate set.',
            retry: 'Retry analysis',
            completed: 'The workflow is complete. This is the confirmed final screening report.',
            riskLevel: 'Overall risk',
            noveltyLabel: 'Novelty',
            inventivenessLabel: 'Inventiveness',
            overall: 'Overall assessment',
            keyRisks: 'Key risks',
            recommendations: 'Recommendations',
            distinguishingFeatures: 'Distinguishing features',
            limitations: 'Evidence limitations',
            candidateAnalysis: 'Candidate-by-candidate comparison',
            similarity: 'Similarity',
            unitAnalysis: 'Key-combination analysis',
            objectiveProblem: 'Objective technical problem',
            technicalEffect: 'Technical effect',
            draftingAdvice: 'Claim drafting recommendations',
            disclosureAdvice: 'Disclosure improvement recommendations',
            independentFeatures: 'Recommended independent-claim features',
            emphasizeFeatures: 'Features to emphasize',
            avoidFeatures: 'Weak sole distinctions',
            draftingNotes: 'Drafting notes',
            supportedFeatures: 'Supported distinguishing features',
            unsupportedFeatures: 'Insufficiently supported features',
            evidenceGaps: 'Evidence gaps',
            inventorQuestions: 'Questions for the inventor',
            confirm: 'Confirm report and complete workflow',
            confirming: 'Confirming…',
            loading: 'Loading patentability analysis…',
            risk: {
                low: 'Low',
                medium: 'Medium',
                high: 'High',
                uncertain: 'Uncertain',
            },
            novelty: {
                novelty_risk: 'Novelty risk',
                likely_novel: 'Likely novel within the current search',
                insufficient_evidence: 'Insufficient evidence',
            },
            inventiveness: {
                obviousness_risk: 'Obviousness risk',
                inventive_indication: 'Inventive indication',
                insufficient_evidence: 'Insufficient evidence',
            },
            disclosure: {
                fully_disclosed: 'Fully disclosed',
                partially_disclosed: 'Partially disclosed',
                not_found: 'Not found',
                uncertain: 'Uncertain',
            },
        },
        handoff: {
            title: 'Continue in Agent',
            description: 'The confirmed workflow is first materialized as a readable Markdown report, then a new document and conversation are created in this project.',
            start: 'Continue in Agent',
            starting: 'Preparing the report and starting…',
            started: 'Agent started with the workflow report attached',
        },
        reinforcement: {
            title: 'Solution reinforcement',
            description: 'Actionable reinforcement suggestions for the novelty/inventiveness risk units.',
            readyHint: 'Click to generate reinforcement suggestions.',
            start: 'Generate',
            starting: 'Generating…',
            queued: 'Queued',
            running: 'Generating reinforcement suggestions…',
            failed: 'Failed to generate reinforcement suggestions',
            retry: 'Retry',
            loading: 'Loading result…',
            confirming: 'Confirming…',
            confirm: 'Confirm result',
            direction: 'Reinforcement direction',
            additionalEffect: 'Additional technical effect',
            draftingNotes: 'Drafting notes',
            summary: 'Summary',
        },
        remaining: {
            title: 'The next step is not connected yet',
            description: 'The candidate set is ready. Novelty and inventiveness analysis follows in the next batch.',
        },
        errors: {
            createFailed: 'Failed to create the guided project',
            loadFailed: 'Failed to load the workflow',
            saveSourceFailed: 'Failed to save the technical solution',
            uploadSourceFailed: 'Failed to upload the workflow file',
            updateSourceFailed: 'Failed to save material order or role',
            ignoreSourceFailed: 'Failed to ignore the failed material',
            deleteSourceFailed: 'Failed to delete the file',
            loadStepFailed: 'Failed to load the workflow step',
            startStepFailed: 'Failed to start the workflow step',
            saveStepFailed: 'Failed to save the workflow step',
            confirmStepFailed: 'Failed to confirm the workflow step',
            loadSearchPlanFailed: 'Failed to load the search plan',
            createSearchPlanFailed: 'Failed to generate the search plan',
            saveSearchPlanFailed: 'Failed to save the search plan',
            confirmSearchPlanFailed: 'Failed to confirm the search plan',
            handoffFailed: 'Failed to prepare the Agent handoff report',
            startAgentFailed: 'Failed to start Agent. The handoff report was preserved for retry.',
        },
    },
};

addLocaleMessages('cn', zhCN);
addLocaleMessages('tw', zhCN);
addLocaleMessages('en', en);
addLocaleMessages('jp', en);
